import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import jwtDecode from 'jwt-decode'
import settings from '../settings'

Vue.use(Vuex)

const tokenName = settings.tokenName;
const signedOutTimeName = 'esv-signedOut';
const serviceRequestTypeSettingsName = 'esv-serviceRequestTypeSettings';

export default new Vuex.Store({
  state: {
    token: localStorage.getItem(tokenName) || '',
    user: localStorage.getItem(tokenName) ? jwtDecode(localStorage.getItem(tokenName)) : {},
    serviceRequestTypeSettings: JSON.parse(localStorage.getItem(serviceRequestTypeSettingsName)) || {},
    uiSettings: {},
    dynamicSearch: null,
    signedOut: localStorage.getItem(signedOutTimeName) || '',
    emailTemp: null,
    tokenId: null,
    authError: false,    
    rejectionReason:null
    },
  mutations: {
    login(state, data) {
      state.token = data.token;
      state.user = jwtDecode(data.token);
      localStorage.setItem(settings.permissionTokenName, data.rolePermissions);
      localStorage.setItem(tokenName, data.token);
      state.tokenId = null;
      // Handle other properties from authenticationResult if necessary
    },
    setServiceRequestTypeSettings(state, settings) {
      state.serviceRequestTypeSettings = settings;
      localStorage.setItem(serviceRequestTypeSettingsName, JSON.stringify(settings));
    },
    refreshPermissions(state, rolePermissions) {
      localStorage.setItem(settings.permissionTokenName, rolePermissions);
    },
    logout(state) {
      console.log('commit logout')
      state.token = '';
      state.tokenId = null;

      localStorage.removeItem(tokenName);
      if (router.currentRoute.name !== 'Login') {
        router.push({ name: 'Login' });
      }
    },
    setADSignOut(state, time) {
      state.signedOut = time;
      localStorage.setItem(signedOutTimeName, time);
    },
    ipForbidden(state) {
      state.token = '';
      localStorage.removeItem(tokenName)
      router.push({ name: 'IPAuthenticationRequest' })
    },
    cultureUpdate(state, cultureId) {
      state.user.selectedCultureId = cultureId;
    },
    setUISettings(state, settings) {
      state.uiSettings = settings;
    },
    dynamicSearch(state, search) {
      state.dynamicSearch = search;
    },
    setEmailTemp(state, email) {
      state.emailTemp = email;
    },
    setTokenId(state) {
      state.tokenId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    setAuthError(state, value) {
      state.authError = value;
    },
    setRejectionReason(state, rejectionReason) {
      state.rejectionReason = rejectionReason;
      //console.log(rejectionReason);
    }
  },
  actions: {
    // You can add actions here if needed
  },
  modules: {
    // You can add modules here if needed
  },
  getters: {
    isAuthenticated: state => !!state.token,
    isInRole: (state) => (...args) => {
      return state.user.role && args.some(a => state.user.role === a || (Array.isArray(state.user.role) && state.user.role.some(r => r === a)))
    },
    recentlySignedOut: (state) => {
      return state.signedOut && state.signedOut < Date.now() + 3600000;
    },
    getServiceRequestTypeSettings: (state) => (serviceRequestTypeId, fieldName) => {
      if (state.serviceRequestTypeSettings[serviceRequestTypeId] && state.serviceRequestTypeSettings[serviceRequestTypeId][fieldName]) {
        return state.serviceRequestTypeSettings[serviceRequestTypeId][fieldName];
      }
      return null;
    },
    getRejectionReason: (state) => {
      return state.rejectionReason;
    }
  }
})
